<template>
  <div class="a-dash-table">
    <v-card width="100%">
      <v-toolbar flat>
        <v-btn icon :to="{ name: 'Dashboard' }" exact>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="text-subtitle-1">
          {{ $t(`table.${$route.query.measure}`) }}
          {{ $route.query.period }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn v-if="!minimize" icon @click="minimize = true">
          <v-icon>mdi-unfold-less-horizontal</v-icon>
        </v-btn>

        <v-btn v-else icon @click="minimize = false">
          <v-icon>mdi-unfold-more-horizontal</v-icon>
        </v-btn>
      </v-toolbar>

      <v-expand-transition>
        <div v-if="!minimize" class="v-card__content">
          <component :is="is"></component>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import { computed, ref } from "vue-demi";

import { useRoute } from "@/composables/router";

import CustomerTableVue from "@/components/DataTable/CustomerTable.vue";
import PotentialTableVue from "@/components/DataTable/PotentialTable.vue";
import DeliveryRateTableVue from "@/components/DataTable/DeliveryRateTable.vue";
import DeliveryLooseTableVue from "@/components/DataTable/DeliveryLooseTable.vue";
import TurnoverTableVue from "@/components/DataTable/TurnoverTable.vue";
import RatingTableVue from "@/components/DataTable/RatingTable.vue";
import PromotionTableVue from "@/components/DataTable/PromotionTable.vue";

export default {
  setup() {
    const route = useRoute();
    const minimize = ref(false);

    const tableComponents = {
      customer: CustomerTableVue,
      potential: PotentialTableVue,
      delivery_rate: DeliveryRateTableVue,
      orders_failed: DeliveryLooseTableVue,
      turnover: TurnoverTableVue,
      rate: RatingTableVue,
      promotion: PromotionTableVue
    };

    const is = computed(() => {
      return tableComponents[route.value.query.measure];
    });

    return {
      minimize,
      is
    };
  }
};
</script>

<style lang="scss">
@import "~vuetify/src/styles/settings/_variables";

.a-dash-table {
  --header-height: 64px;
  --padding: calc(4px * 2);

  position: fixed;
  z-index: 402;
  pointer-events: none;

  padding: var(--padding);
  width: 100%;
  height: 100%;

  .v-card {
    pointer-events: all;

    .v-toolbar {
      height: var(--header-height);
    }

    .v-card__content {
      height: calc(100vh - var(--header-height) - var(--padding) * 2);
      overflow-y: scroll;
    }
  }

  @media (min-width: 1000px) {
    width: 50%;
  }

  @media (min-width: 1300px) {
    width: 40%;
  }

  @media (min-width: 1600px) {
    width: 40%;
  }

  table {
    tbody {
      tr {
        cursor: pointer;
      }
    }
  }
}
</style>
